import { render, staticRenderFns } from "./BlackGoldAlertModal.vue?vue&type=template&id=2f943a2b&"
import script from "./BlackGoldAlertModal.vue?vue&type=script&lang=js&"
export * from "./BlackGoldAlertModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports